import React, { useEffect, useState, useRef } from 'react';
import add from "../../../../../../../assets/add-icon.svg";
import { withRouter } from 'react-router';
import DataTable from 'react-data-table-component';
import { motion } from 'framer-motion';
import { BACK_DROP_FALSE } from '../../../../../../../Util/helper';
import Popup from 'reactjs-popup';
import close from "../../../../../../../assets/close.svg";
import { config } from '../../../../../../../config';
import axiosApi from '../../../../../../../core/interceptor/interceptor';
import WarningDialogue from '../../../../../../../Util/WarningDialogue';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function LevelOfPlay() {
  const columns = [
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Name</div>,
      selector: () => 'name',
      className: 'left-align',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.name ? `${row.name}` : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Description</div>,
      selector: () => 'description',
      className: 'left-align',
      minWidth: '130px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.description ? `${row.description}` : 'N/A'}</div>)
    },
    {
      name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Action</div>,
      selector: () => 'shirt_size',
      minWidth: '98px !important',
      sortable: 'true',
      style: {
        padding: '0'
      },
      cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', gap: '10px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>
        <button className="btn" onClick={() => {
          setFormData(row);
          setOpen(true);
        }}>Edit</button>
        <button onClick={() => {
          setFormData(row);
          setIsWarning(true);
        }} className="btn">
          Delete
        </button>
      </div>)
    },
  ];
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: '', description: '', id: 0 })
  const [data, setData] = useState([]);
  const [isWarning, setIsWarning] = useState(false);
  const [requesComplete, setRequesComplete] = useState(false);

  useEffect(() => {
    getAll();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const save = () => {
    axiosApi.post(`${config.apiUrl}/level-of-play`, formData).then((res) => {
      clearForm();
      getAll();
    }).catch((err) => {
      console.error(err);
    });
  }

  const update = () => {
    axiosApi.put(`${config.apiUrl}/level-of-play/${formData.id}`, formData).then((res) => {
      clearForm();
      getAll();
    }).catch((err) => {
      console.error(err);
    })
  }

  const getAll = () => {
    axiosApi.get(`${config.apiUrl}/level-of-play`).then((res) => {
      if (res.data.data) {
        setData(res.data.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setRequesComplete(true);
    });
  }

  const deleteLevelOfPlay = (id) => {
    axiosApi.delete(`${config.apiUrl}/level-of-play/${id}`).then((res) => {
      clearForm();
      getAll();
    }).catch((err) => {
      console.error(err);
    })
  }

  const clearForm = () => {
    setIsWarning(false);
    setOpen(false);
    setFormData({ name: '', description: '', id: 0 });
  }
  return (
    <motion.div>
      <div className="content-wrapper message-template-wrapper ns-temp-wrapper">
        <div className="heading-wrapper">
          <div class="left">
            <h1 class="heading">Level of Play</h1>
          </div>
          <div class="right">
            <button className="ns-top-btn-size" onClick={() => setOpen(true)}><img src={add} alt='add-league' /><b>Add</b> Level of Play</button>
          </div>
        </div>
        <div className="table-wrapper">
          <div className="heading-blk">
            <div className="left">
              <h2>Results</h2>
              <p>Select a row to modify Level of Play</p>
            </div>
          </div>
          <div className='dataTable active lop-table'>
            <DataTable
              persistTableHead={true}
              columns={columns}
              data={data}
              paginationPerPage={50}
              noDataComponent={requesComplete && <div className="noRecord-found">{'No Record Found'}</div>}
              paginationRowsPerPageOptions={[10, 20, 50, 100, 200]}
            ></DataTable>
          </div>
        </div>
      </div>
      <Popup open={open} closeOnDocumentClick={BACK_DROP_FALSE} onClose={() => clearForm()} >
        <div className="modal">
          <div className="modal-header">
            <h2>Add Level of Play</h2>
            <span className="close" onClick={() => clearForm()}>
              <img src={close} alt='close-img' />
            </span>
          </div>
          <div className="modal-content">
            <div className="input-field">
              <label>Name<sup>*</sup></label>
              <input type="text" name="name" value={formData.name} onChange={handleChange} />
              {/* {formSubmitted && <span className="error">{errors["firstName"]}</span>} */}
            </div>
            <div className="input-field">
              <label>Description</label>
              <textarea name="description" value={formData.description} className="ns-textarea-size" onChange={handleChange}></textarea>
              {/* {formSubmitted && <span className="error">{errors["firstName"]}</span>} */}
            </div>
          </div>
          <div className="modal-footer d-flex">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => clearForm()}>Cancel</button>
            <button onClick={formData.id > 0 ? update : save}> {formData.id > 0 ? 'update' : 'Save'}</button>
          </div>
        </div>
      </Popup>
      <WarningDialogue
        isOpen={isWarning}
        header={'Warning'}
        description={`Are you sure, you want to delete Level of Play?`}
        icon={faExclamationTriangle}
        data={formData}
        action={(data) => {
          deleteLevelOfPlay(data.id);
        }}
        onClose={clearForm}
      />
    </motion.div>
  )
}
export default withRouter(LevelOfPlay);